export default __webpack_public_path__ + "static/media/HCS2023_program-abstracts_2023-07-27.6caa0e44.pdf";